const API_URL = process.env.REACT_APP_API_URL || 'https://main.victriedemos.com:3011';

async function request(path, options = {}) {
  const res = await fetch(`${API_URL}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  });

  const data = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(data?.error || `Request failed (${res.status})`);
  }
  return data;
}

export function getPackages(type) {
  const query = type ? `?type=${encodeURIComponent(type)}` : '';
  return request(`/api/packages${query}`);
}

export function checkUsername(username) {
  return request(`/api/register/check-username?username=${encodeURIComponent(username)}`);
}

export function verifyRegistration(payload) {
  return request('/api/register/verify', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function submitSupportRequest(payload) {
  return request('/api/support/submit', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export { API_URL };
